<div>
    <mat-drawer-container [hasBackdrop]="false" autosize style="height: calc(100vh - 50px); width:100%">
        <mat-drawer #drawer mode="side" opened style="display: block;">
            <div class="heading">Teams</div>
            <div *ngIf="!noFolders">
                <div class="input-group-sm mt-2 input-group col-12">
                  <input
                    class="form-control"
                    type="search"
                    (keyup)="applyFilterOnFolders($event)"
                    (search)="applyFilterOnFolders($event)"
                    placeholder="Filter Team name"
                  />
                </div>
            </div>
            <div class="clearfix mt-1 mr-1"><button mat-stroked-button (click)="createFolder()" class="float-right pr-2">
                    <mat-icon>add</mat-icon> New
                </button>
            </div>
            <div class="m-2 text-center" *ngIf="noFolders">
                No Teams to view
            </div>
            <mat-tree *ngIf="!noFolders" [dataSource]="virtualFolders" [treeControl]="treeControl">
                <!-- This is the tree node template for leaf nodes -->
                <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding [matTreeNodePaddingIndent]="20">
                    <!-- use a disabled button to provide padding for tree leaf -->
                    <button mat-icon-button matTreeNodeToggle style="min-width: 20px;" [attr.aria-label]="'toggle ' + node.team_name">
                        <mat-icon class="mat-icon-rtl-mirror">
                            {{treeControl.isExpanded(node) ? 'folder_open' : 'folder_open'}}
                        </mat-icon>
                    </button>
                    <button [ngClass]="node.id === selectedFolderId ? 'bold-text' : 'normal-text'" mat-button (click)="selectTeam(node.team_name, node.id)">
                             {{node.team_name}}
                    </button>
                </mat-tree-node>
                <!-- This is the tree node template for expandable nodes -->
                <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding
                    [matTreeNodePaddingIndent]="20">
                    <button mat-icon-button matTreeNodeToggle style="min-width: 20px;" [attr.aria-label]="'toggle ' + node.team_name">
                        <mat-icon class="mat-icon-rtl-mirror">
                            {{treeControl.isExpanded(node) ? 'folder_open' : 'folder'}}
                        </mat-icon>
                    </button>
                    <button [ngClass]="node.id === selectedFolderId ? 'bold-text' : 'normal-text'" mat-button (click)="selectTeam(node.team_name, node.id)">
                        {{node.team_name}}</button>
                </mat-tree-node>
            </mat-tree>
        </mat-drawer>

        <mat-drawer-content>
            <div class="m-2">
                <div class="btn-group fit-content mt-2 mb-2">
                    <button class="btn pr-2" mat-stroked-button (click)="deleteFolder()">
                        <mat-icon class="mb-1">add</mat-icon> Delete Team
                    </button>                        
                    <span class="fill-remaining-space col-1"></span>                                               
                </div>
            </div>
            <div class="card m-2" *ngIf="folders.length == 0">
                
                <div class="card-body"><strong>Please select a option </strong>
                    <br> 1. To create a new team.<br>
                    <br> 2. To update existing team.<br>
                    <br> 3. To delete existing team.<br>
                </div>
            </div>
            <div *ngIf = "(isCreateFolder ) && !isUpdateFolder">
                <div *ngIf = "!folderSelected && isCreateFolder" class="Tabletitle">Create Team</div>                
                <div *ngIf = "!folderSelected" class="card-body">
                    <form [formGroup]="createFormData">
                        <div class="input-group-sm mb-3 input-group col-12">
                            <div class="input-group-prepend">
                                <span class="input-group-text form-label-105">Name</span>
                
                            </div>
                            <input type="text" class="form-control" id="retention-name" formControlName="team_name" name="retention-name" >
                        </div>
                        <!-- <div class="input-group-sm mb-3 input-group col-12">
                            <div class="input-group-prepend">
                                <span class="input-group-text form-label-105">Personal</span>
                            </div>
                            <mat-slide-toggle class="pl-2 pr-2 pt-1" (click)="togglePersonal()" formControlName="personal">
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </mat-slide-toggle>
                        </div> -->
                        <div class="input-group-sm mb-3 input-group col-12">
                            <div class="input-group-prepend">
                                <span class="input-group-text form-label-105">Groups</span>
                            </div>
                            <mat-select formControlName="groups"  multiple class="form-control">
                                <mat-option>
                                    <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'" [noEntriesFoundLabel]="'Not found'" name="search" [ngModelOptions]="{standalone: true}">
                                    </ngx-mat-select-search>
                                </mat-option>
                                <div *ngFor="let group of fetchedGroups |stringFilter:searchCtrl:'name'">
                                    <mat-option  [value]="group">
                                        {{group}}
                                    </mat-option>
                                </div>
                            </mat-select>
                        </div>                        
                        <button mat-raised-button class="actionButton m-2" style="float: right" [disabled]="!createFormData.valid" (click)="saveCreateData(createFormData.value)" mat-button>Create</button>
                
                    </form>
                </div>                
            </div>
            <div *ngIf = "!isCreateFolder && isUpdateFolder">
                <div *ngIf = "folderSelected" class="Tabletitle">View Team</div>
                <div *ngIf = "folderSelected" class="card-body">
                    <form [formGroup]="createFormData">
                        <div class="input-group-sm mb-3 input-group col-12">
                            <div class="input-group-prepend">
                                <span class="input-group-text form-label-105">Name</span>
                
                            </div>
                            <input type="text" class="form-control" id="retention-name" formControlName="team_name" name="folder-name" >
                        </div>
                        <!-- <div class="input-group-sm mb-3 input-group col-12">
                            <div class="input-group-prepend">
                                <span class="input-group-text form-label-105">Personal</span>
                            </div>
                            <mat-slide-toggle class="pl-2 pr-2 pt-1" (click)="togglePersonal()" formControlName="personal">
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </mat-slide-toggle>
                        </div> -->
                        <div class="input-group-sm mb-3 input-group col-12">
                            <div class="input-group-prepend">
                                <span class="input-group-text form-label-105">Groups</span>
                            </div>
                            <mat-select formControlName="groups" multiple class="form-control">
                                <mat-option>
                                    <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'" [noEntriesFoundLabel]="'Not found'" name="search" [ngModelOptions]="{standalone: true}">
                                    </ngx-mat-select-search>
                                </mat-option>
                                <mat-option *ngFor="let group of fetchedGroups | stringFilter:searchCtrl:'name'" [value]="group">
                                    {{group}}</mat-option>
                            </mat-select>
                        </div>                
                  
                        
                        <button mat-raised-button class="actionButton m-2" style="float: right" [disabled]="!createFormData.valid" (click)="saveUpdateData(createFormData.value)" mat-button>Update</button>
                
                
                
                    </form>
                </div>
                
            </div>            
        </mat-drawer-content>
    </mat-drawer-container>
</div>